export default __webpack_public_path__ + "img/x-white.ac5a8922.svg";